import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight, Check } from "lucide-react";
import { toast } from "sonner";
import OpsTopBar from "../../components/ops/OpsTopBar";
import { BranchAvatar } from "../../components/ops/BranchAvatar";
import { PlatformIcon, FormatTag } from "../../components/ops/Pills";
import useApi from "../../hooks/useApi";
import api from "../../lib/api";

export default function OpsAttention() {
  const { data, refetch } = useApi("/ops/exceptions");
  const items = data?.exceptions || [];

  const resolve = async (id) => {
    await api.post(`/ops/exceptions/${id}/resolve`);
    toast.success("Resolved — returned to queue");
    refetch();
  };

  return (
    <>
      <OpsTopBar title="Requires Attention" subtitle={`${items.length} exceptions`} />
      <div className="p-6 sm:p-8 max-w-[1100px] space-y-4">
        {items.length === 0 && (
          <div className="card p-10 text-center">
            <span className="grid place-items-center w-12 h-12 rounded-full mx-auto" style={{ background: "var(--grad-green-soft)" }}><Check size={22} color="#5F8213" strokeWidth={2} /></span>
            <p className="text-ink font-semibold mt-3">All clear</p>
            <p className="text-ink-2 text-sm">No exceptions need your attention right now.</p>
          </div>
        )}
        {items.map((t) => (
          <div key={t.id} className="card p-5" data-testid={`exception-${t.id}`}>
            <div className="flex items-start gap-4">
              <span className="grid place-items-center w-11 h-11 rounded-xl shrink-0" style={{ background: "rgba(208,82,107,.12)" }}><AlertTriangle size={20} color="#D0526B" strokeWidth={1.75} /></span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-bold text-ink">{t.exception_type || "Requires attention"}</span>
                  <span className="text-xs font-bold uppercase tracking-wide rounded-full px-2 py-0.5" style={{ background: "rgba(208,82,107,.12)", color: "#D0526B" }}>{t.priority}</span>
                </div>
                <p className="text-sm text-ink-2 mt-1">{t.note}</p>
                <div className="flex items-center gap-3 mt-3 text-sm">
                  <BranchAvatar initials={t.branch_initials} color={t.branch_color} size={28} />
                  <span className="font-medium text-ink">{t.branch_name} · {t.group_name}</span>
                  <span className="text-ink-3 flex items-center gap-1.5"><PlatformIcon platform={t.platform} size={13} /> {t.handle}</span>
                  <FormatTag format={t.format} />
                </div>
              </div>
              <div className="flex flex-col gap-2 shrink-0">
                <button onClick={() => resolve(t.id)} className="btn-primary focus-ring text-sm" data-testid={`resolve-${t.id}`}><Check size={14} strokeWidth={2.5} /> Resolve</button>
                <Link to={`/ops/task/${t.id}`} className="btn-secondary focus-ring text-sm justify-center" data-testid={`open-task-${t.id}`}>Open task <ArrowRight size={13} /></Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
